import { render, staticRenderFns } from "./ProjectNewStatus.vue?vue&type=template&id=61d5ebc6&scoped=true&"
import script from "./ProjectNewStatus.vue?vue&type=script&lang=ts&"
export * from "./ProjectNewStatus.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectNewStatus.vue?vue&type=style&index=0&id=61d5ebc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d5ebc6",
  null
  
)

export default component.exports